import { UntypedFormGroup } from '@angular/forms';
import { MimeType } from '../../enums/mime-types.enum';
import {
    Condition,
    ConditionalFields,
    ConditionElement,
    FormElement,
    MwfElementTypes,
    MwfFileType,
    PageBreakElement,
} from './caas-monday-webforms.interface';

export const getIDPathByFormElementName = (name: string, form: UntypedFormGroup) => {
    let elementPath = '';

    for (const formGroup of Object.entries(form.controls)) {
        if (formGroup[1] instanceof UntypedFormGroup) {
            if (formGroup[1].contains(name)) {
                elementPath = `${formGroup[0]}.${name}`;
                break;
            }
        }
    }

    return elementPath;
};

export const isPageBreakElement = (element: any): element is PageBreakElement =>
    !!element && element.type !== undefined && element.type === MwfElementTypes.PAGE_BREAK;

export const isConditionElement = (element: any): element is ConditionElement =>
    !!element && element.type !== undefined && element.type === MwfElementTypes.CONDITION;

export const isFormElement = (element: any): element is FormElement =>
    !!element &&
    element.type !== undefined &&
    (element.type === MwfElementTypes.INPUT_FIELD ||
        element.type === MwfElementTypes.CAPTCHA ||
        element.type === MwfElementTypes.CHECK_BOX_GROUP ||
        element.type === MwfElementTypes.COMBO_BOX ||
        element.type === MwfElementTypes.FILE_UPLOAD ||
        element.type === MwfElementTypes.PARAGRAPH ||
        element.type === MwfElementTypes.RADIO_GROUP ||
        element.type === MwfElementTypes.RICH_TEXT_ELEMENT ||
        element.type === MwfElementTypes.TEXT_AREA);

export const isConditionArray = (array: any): array is Condition[] =>
    !!array &&
    Array.isArray(array) &&
    array.length > 0 &&
    array[0].operator !== undefined &&
    array[0].value !== undefined;

export const isConditionalFieldsArray = (array: any): array is ConditionalFields[] =>
    !!array && Array.isArray(array) && array.length > 0 && array[0].state !== undefined;
export const fileTypeMapper = (mwfFiletype: string) => {
    switch (mwfFiletype) {
        case MwfFileType.JPG:
            return MimeType.JPG as string;
        case MwfFileType.JPEG:
            return MimeType.JPEG as string;
        case MwfFileType.PNG:
            return MimeType.PNG as string;
        case MwfFileType.MP4:
            return MimeType.MP4 as string;
        case MwfFileType.PDF:
            return MimeType.PDF as string;
        case MwfFileType.DOC:
            return MimeType.DOC as string;
        case MwfFileType.TXT:
            return MimeType.TXT as string;
        case MwfFileType.XLSX:
            return MimeType.XLSX as string;
        case MwfFileType.XLS:
            return MimeType.XLS as string;
        case MwfFileType.DOCX:
            return MimeType.DOCX as string;
        case MwfFileType.XML:
            return MimeType.XML as string;
        default:
            return null;
    }
};
